import apiService from '@/services/apiService';

const actions = {
  getCorpPartnerLists({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/partner/find-with-paging', payload)
        .then((response) => {
          commit('getCorpPartnerLists', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCorpPartnerList({ commit }, payload) {
    apiService.get(`corporate-sales/partner/${payload}`)
      .then((response) => {
        commit('getCorpPartnerList', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateStatusCorpPartnerList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/partner/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderCorpPartnerList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/partner/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postCorpPartnerList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/partner', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCorpPartnerList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/partner/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delCorpPartnerList({ commit }, payload) {
    apiService.delete(`corporate-sales/partner/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
